<div class="text-center">
  <img src="assets/error.png" alt="Success" style="width: 80px">
</div>

<h3 class="mt-4">Übermittlung fehlgeschlagen!</h3>
<p>
  Ihre Daten konnten nicht an die Kanzlei von von MMag. Dr. Linus Mähr übermittelt werden!<br>
  Bitte melden Sie sich telefonisch bei der Kanzlei unter +43 5523 55612<br>
</p>
